import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { getNowAiring, SHOWS_BY_SLUG } from "@/data/content";
import { Radio, ArrowRight } from "lucide-react";

export default function NowAiring() {
    const [state, setState] = useState(() => getNowAiring());
    useEffect(() => {
        const id = setInterval(() => setState(getNowAiring()), 30000);
        return () => clearInterval(id);
    }, []);

    const show = state.current ? SHOWS_BY_SLUG[state.current.show] : null;
    const nextShow = state.next ? SHOWS_BY_SLUG[state.next.show] : null;

    return (
        <section data-testid="now-airing-strip" className="relative z-10 mx-auto -mt-16 w-full max-w-6xl px-4 sm:px-6">
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 1.1, ease: [0.16, 1, 0.3, 1] }}
                className="gold-border-glow overflow-hidden rounded-2xl bg-[#16162B]/90 backdrop-blur-xl"
            >
                <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:gap-6 sm:p-6">
                    <div className="flex items-center gap-3">
                        <span className="onair-dot h-3 w-3 rounded-full bg-[#C8102E]" />
                        <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#E85050]">
                            {show ? "Now Airing" : "Up Next"}
                        </span>
                    </div>
                    <div className="min-w-0 flex-1">
                        {show ? (
                            <>
                                <p className="font-display truncate text-lg font-bold text-white sm:text-xl">
                                    {show.title}
                                    <span className="ml-3 text-sm font-medium text-[#9999BB]">{state.current.t}</span>
                                </p>
                                <div className="mt-2 h-1 w-full overflow-hidden rounded-full bg-white/10">
                                    <div
                                        data-testid="now-airing-progress"
                                        className="h-full rounded-full bg-gradient-to-r from-[#FFA200] to-[#C8102E] transition-[width] duration-1000"
                                        style={{ width: `${Math.round(state.progress * 100)}%` }}
                                    />
                                </div>
                            </>
                        ) : (
                            <p className="font-display text-lg font-bold text-white sm:text-xl">
                                Programming resumes at 7:00 AM
                            </p>
                        )}
                    </div>
                    {nextShow && (
                        <div className="flex items-center gap-3 border-t border-white/10 pt-3 sm:border-l sm:border-t-0 sm:pl-6 sm:pt-0">
                            <div className="min-w-0">
                                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#9999BB]">Up Next</p>
                                <p className="truncate text-sm font-semibold text-white">
                                    {nextShow.title} · {state.next.t}
                                </p>
                            </div>
                            <Radio size={18} className="shrink-0 text-[#FFA200]" />
                        </div>
                    )}
                    <Link
                        to="/schedule"
                        data-testid="now-airing-schedule-link"
                        className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[#C8102E]/50 px-4 py-2 text-xs font-bold uppercase tracking-[0.15em] text-white transition-colors hover:bg-[#C8102E]"
                    >
                        Full Schedule <ArrowRight size={14} />
                    </Link>
                </div>
            </motion.div>
        </section>
    );
}
